import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Sidebar({ isOpen }) {
  const { t } = useTranslation();
  const [expandedGroups, setExpandedGroups] = useState({
    dashboard: true,
    customer: true,
    system: false,
    config: false,
    report: true
  });

  const menuGroups = [
    {
      id: 'dashboard',
      label: t('sidebar.dashboard'),
      icon: 'bi-speedometer2',
      items: [
        { path: '/', icon: 'bi-speedometer2', label: t('sidebar.dashboard') }
      ]
    },
    {
      id: 'customer',
      label: t('sidebar.customerManagement'),
      icon: 'bi-people-fill',
      items: [
        { path: '/customers', icon: 'bi-person-circle', label: t('sidebar.customers') },
        { path: '/customer-groups', icon: 'bi-people-fill', label: t('sidebar.customerGroups') },
        { path: '/warnings', icon: 'bi-exclamation-triangle-fill', label: t('sidebar.warnings') },
        { path: '/alerts', icon: 'bi-exclamation-triangle', label: t('sidebar.alerts') }
      ]
    },
    {
      id: 'system',
      label: t('sidebar.systemManagement'),
      icon: 'bi-gear-fill',
      items: [
        { path: '/users', icon: 'bi-people', label: t('sidebar.users') },
        { path: '/branches', icon: 'bi-building', label: t('sidebar.branches') },
        { path: '/positions', icon: 'bi-person-badge', label: t('sidebar.positions') },
        { path: '/departments', icon: 'bi-diagram-3', label: t('sidebar.departments') },
        { path: '/permissions', icon: 'bi-shield-check', label: t('sidebar.permissions') }
      ]
    },
    {
      id: 'config',
      label: t('sidebar.settings'),
      icon: 'bi-sliders',
      items: [
        { path: '/system-config', icon: 'bi-sliders2', label: t('sidebar.systemConfig') },
        { path: '/data-sources', icon: 'bi-database', label: t('sidebar.dataSources') },
        { path: '/data-upload', icon: 'bi-cloud-upload', label: t('sidebar.dataUpload') },
        { path: '/data-repository', icon: 'bi-database-fill-gear', label: t('sidebar.dataRepository') },
        { path: '/models', icon: 'bi-diagram-3', label: t('sidebar.models') },
        { path: '/indicators', icon: 'bi-bar-chart', label: t('sidebar.indicators') },
        { path: '/workflows', icon: 'bi-diagram-2', label: t('sidebar.workflows') },
        { path: '/case-management', icon: 'bi-kanban', label: t('sidebar.cases') },
        { path: '/case-filter-rules', icon: 'bi-funnel', label: t('sidebar.caseFilterRules') }
      ]
    },
    {
      id: 'report',
      label: t('sidebar.reports'),
      icon: 'bi-file-earmark-bar-graph',
      items: [
        { path: '/reports', icon: 'bi-file-earmark-bar-graph', label: t('sidebar.reports') }
      ]
    }
  ];

  const toggleGroup = (groupId) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };

  return (
    <div className={`sidebar bg-dark text-white ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-brand">
        <i className="bi bi-shield-check me-2"></i>
        {isOpen && <span>EWS System</span>}
      </div>
      
      <nav className="sidebar-nav">
        {menuGroups.map((group) => (
          <div key={group.id} className="menu-group">
            {isOpen ? (
              <div
                className={`menu-group-header ${expandedGroups[group.id] ? 'expanded' : ''}`}
                onClick={() => toggleGroup(group.id)}
              >
                <div className="menu-group-title">
                  <i className={`bi ${group.icon} me-2`}></i>
                  <span>{group.label}</span>
                </div>
                <i className={`bi bi-chevron-${expandedGroups[group.id] ? 'down' : 'right'}`}></i>
              </div>
            ) : (
              <div
                className="menu-group-header-collapsed"
                title={group.label}
              >
                <i className={`bi ${group.icon}`}></i>
              </div>
            )}
            
            {/* Submenu for open sidebar */}
            {isOpen && expandedGroups[group.id] && (
              <div className="menu-group-items">
                {group.items.map((item) => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                    title={item.label}
                    end={item.path === '/'}
                  >
                    <i className={`bi ${item.icon}`}></i>
                    <span>{item.label}</span>
                  </NavLink>
                ))}
              </div>
            )}

            {/* Hover submenu for collapsed sidebar */}
            {!isOpen && (
              <div className="menu-group-submenu">
                <div className="menu-group-submenu-header">
                  {group.label}
                </div>
                {group.items.map((item) => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                    title={item.label}
                    end={item.path === '/'}
                  >
                    <i className={`bi ${item.icon}`}></i>
                    <span>{item.label}</span>
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>
    </div>
  );
}

export default Sidebar;
